export default __webpack_public_path__ + "static/media/support-team-trevor.d0b7bbcb.png";